import { Box, Button, Group, Stack, Title } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconPlus } from "@tabler/icons-react";
import { AddLayerForm } from "shared/components/organization/geolocations/AddLayerForm";
import { AddShapeForm } from "shared/components/organization/geolocations/AddShapeForm";
import { LayersList } from "shared/components/organization/geolocations/LayersPanelList";
import { useGeoLocations } from "shared/components/organization/geolocations/useGeoLocations";
import { useIsMobile } from "shared/hooks/useIsMobile";

export const LayersPanel = () => {
    const isMobile = useIsMobile();
    const geo = useGeoLocations();

    function handleAddLayer() {
        modals.open({
            title: "Create Layer",
            children: <AddLayerForm onCancel={modals.closeAll} />,
        });
    }

    return (
        <Stack
            w={isMobile ? "100%" : 420}
            h={isMobile && geo.drawingLayerId ? "auto" : "100%"}
            gap="xs"
            p="md"
            style={{
                flexShrink: 0,
                minHeight: isMobile && geo.drawingLayerId ? "auto" : "100%",
                borderLeft: isMobile ? undefined : "1px solid var(--app-shell-border-color)",
                backgroundColor: "var(--mantine-color-body)",
                overflow: "hidden",
            }}
        >
            <Group justify="space-between" align="flex-end">
                <Title order={4}>{geo.editingShape ? "Edit Shape" : geo.drawingLayerId ? "Add Shape" : "Layers"}</Title>
                {!geo.drawingLayerId && (
                    <Button
                        variant="subtle"
                        size="compact-sm"
                        leftSection={<IconPlus size={14} />}
                        onClick={handleAddLayer}
                        disabled={!!geo.drawingLayerId}
                    >
                        Add Layer
                    </Button>
                )}
            </Group>
            <Box style={{ flex: 1, minHeight: 0, overflow: "auto" }}>{geo.drawingLayerId ? <AddShapeForm /> : <LayersList />}</Box>
        </Stack>
    );
};
